import { ROLES, type Role } from "../constants/permissions";

export interface IRole {
    Id: string;
    Name: string;
    Description?: string;
    OrganizationId?: string | null;
    OrganizationName?: string | null;
    IsDefault?: boolean | number;
    CreatedAt?: string;
    UpdatedAt?: string;
}

/** Platform-wide default roles — not editable or deletable. */
export const DEFAULT_PLATFORM_ROLE_IDS = [
    ROLES.ADMIN_OWNER,
    ROLES.INSTALL,
    ROLES.PRODUCTION,
    ROLES.SALES,
    ROLES.SUPER_ADMIN,
] as const satisfies readonly Role[];

export const SUPER_ADMIN_ROLE_ID = ROLES.SUPER_ADMIN;
export const ADMIN_OWNER_ROLE_ID = ROLES.ADMIN_OWNER;

export function isDefaultPlatformRole(role: Pick<IRole, "Id" | "OrganizationId" | "IsDefault">): boolean {
    if (role.IsDefault === true || role.IsDefault === 1) return true;
    if (role.OrganizationId == null || role.OrganizationId === "") return true;
    return (DEFAULT_PLATFORM_ROLE_IDS as readonly string[]).includes(role.Id);
}
